var map = {
	"./cyber-security.webp": 22794,
	"./microsoft-365.webp": 33420,
	"./microsoft-azure.webp": 755,
	"./power-automate.webp": 7609,
	"./power-bi.webp": 29280,
	"./students.webp": 39956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60143;